
import React from "react";
import { Accordion, AccordionPanel, Panel, TabPane, TabPanel } from '@ronuse/norseu/core/panels';
import Helpers from "../../../utils/Helpers";
import { Button } from "@ronuse/norseu/core/buttons";
import { Alignment, Scheme } from "@ronuse/norseu/core/variables";
import { Dropdown } from "@ronuse/norseu/core/form";

export class TabPanePage extends React.Component {

    constructor(props) {
        super(props);
        this.willUnmount = false;
        this.previewPanels = React.createRef();
        this.previewPanels.current = [];
    }

    componentWillUnmount() {
        this.willUnmount = true;
    }

    buildDocumentation() {
        let alignNavigatorOptions = [
			{ label: "Alignment.LEFT", value: Alignment.LEFT },
			{ label: "Alignment.RIGHT", value: Alignment.RIGHT },
			{ label: "Alignment.TOP", value: Alignment.TOP },
			{ label: "Alignment.CENTER", value: Alignment.CENTER },
			{ label: "Alignment.TOP_CENTER", value: Alignment.TOP_CENTER },
			{ label: "Alignment.TOP_LEFT", value: Alignment.TOP_LEFT },
			{ label: "Alignment.TOP_RIGHT", value: Alignment.TOP_RIGHT },
			{ label: "Alignment.BOTTOM", value: Alignment.BOTTOM },
			{ label: "Alignment.BOTTOM_LEFT", value: Alignment.BOTTOM_LEFT },
			{ label: "Alignment.BOTTOM_RIGHT", value: Alignment.BOTTOM_RIGHT },
			{ label: "Alignment.BOTTOM_CENTER", value: Alignment.BOTTOM_CENTER },
		];

        return (
            <React.Fragment>
                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Basic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text1()}
                                    <br/><Button text="Click Me" />
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Header with Icon</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}} icon="fa fa-eye">
                                    {TabPanePage.text1()}
                                    <br/><Button text="Click Me" />
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}} icon="fa fa-code">
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}} icon="fa fa-user" rightIcon="fa fa-arrow-right">
                                    {TabPanePage.text3()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Extra TabNavigator Elements</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}} icon="fa fa-eye">
                                    {TabPanePage.text1()}
                                    <br/><Button text="Click Me" />
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}} icon="fa fa-code">
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}} icon="fa fa-user" rightIcon="fa fa-arrow-right">
                                    {TabPanePage.text3()}
                                </TabPanel>

                                <div className="norseu-flex" style={{alignItems:"center",float:"right"}}>
                                    <input type="text" placeholder="" style={{height:"30px"}}/>
                                    <Button scheme={Scheme.PRIMARY} text="Search"/>
                                </div>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">TabPanel with Scheme</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}} icon="fa fa-eye" scheme={Scheme.PRIMARY}>
                                    {TabPanePage.text1()}
                                    <br/><Button text="Click Me" />
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}} icon="fa fa-code" scheme={Scheme.WARNING}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}} icon="fa fa-user" rightIcon="fa fa-arrow-right"  scheme={Scheme.INFO}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}} icon="fa fa-times"  scheme={Scheme.DANGER}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Skeleton</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} scheme={Scheme.SKELETON} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text1()}
                                    <br/><Button text="Click Me" /> <Button text="Click Me" />
                                    <br/><Button text="Click Me" /> <Button text="Click Me" />
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Disabled tab</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <TabPane activeTabIndex={0} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text1()}
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}} disabled>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Custom Logic</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Button text="Switch to Panel 1" scheme={Scheme.INFO} onClick={() => this.setState({ activeTabIndex: 0 })} outlined/>
                            <Button text="Switch to Panel 2" scheme={Scheme.INFO} onClick={() => this.setState({ activeTabIndex: 1 })} outlined/>
                            <Button text="Switch to Panel 3" scheme={Scheme.INFO} onClick={() => this.setState({ activeTabIndex: 2 })} outlined/>
                            <TabPane activeTabIndex={this.state.activeTabIndex} onTabChange={(e) => this.setState({ activeTabIndex: e.index })} renderActiveTabOnly>
                                <TabPanel title="Panel 1" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text1()}
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                                {/*<Button text="Extra Button"/>*/}
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>

                <Panel borderless style={{ marginTop: 40 }}>
                    <span className="norseu-showcase-component-page-preview-title">Tab Navigator Allignment</span>
                    <Accordion borderless multiple activeIndex={[0]}>
                        <AccordionPanel noheader nodivier className="norseu-showcase-component-page-preview">
                            <p className="documentation-p"></p>
                            <Dropdown options={alignNavigatorOptions} selectedOptionIndex={2} onSelectOption={(e) => this.setState({ alignNavigator: e.option.value } )}/>
                            <br/>
                            <TabPane activeTabIndex={0} alignNavigator={this.state.alignNavigator} renderActiveTabOnly>
                                <TabPanel title="Panel 1" icon="fa fa-user" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text1()}
                                </TabPanel>
                                <TabPanel title="Panel 2" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text2()}
                                </TabPanel>
                                <TabPanel title="Panel 3" contentStyle={{padding:"10px"}}>
                                    {TabPanePage.text3()}
                                </TabPanel>
                            </TabPane>
                            
                            <div className="norseu-showcase-component-page-preview-buttons">
                                <i className="fa fa-code" onClick={(e) => this.previewPanels.current[0].toggle()}></i>
                                <i className="fa fa-copy" onClick={(e) => {Helpers.copyToClipboard(this.state.pageSource, [[57, 65]])}}></i>
                            </div>
                        </AccordionPanel>
                        {Helpers.getSourceInEditorR(this.state.pageSource, (ref) => this.previewPanels.current[0] = ref, [[57, 65]])}
                    </Accordion>
                </Panel>
            </React.Fragment>
        );
    }

    render() {
        return Helpers.buildComponentPage(this, {
            title: "TabPane",
            import_statement: "import { TabPane } from '@ronuse/norseu/core/panels'",
            properties: this.properties,
            css_map: this.cssMap,
            ref_map: this.refMap,
            documentation: this.buildDocumentation(),
            page_source: this.state.pageSource,
            show_dialog: this.state.showSourceDialog,
            source_url: "https://raw.githubusercontent.com/ronuse/norseu/main/showcase/src/components/core/panels/TabPanePage.js"
        });
    }

    state = {
        pageSource: '',
        showSourceDialog: false,
        alignNavigator: Alignment.TOP
    };

    cssMap = [

    ];

    properties = [
        { name: "text", type: "string", default: "", description: "The label to show in the button" },
    ];
    
    refMap = [
        { name: "value()", type: "function", description: "Returns the value of the component internal HTML element" },
        { name: "setValue(value)", type: "function", description: "Set the value of the component internal HTML element" },
        { name: "focus()", type: "function", description: "Send focus to the component" },
        { name: "getInternalElement()", type: "function", description: "Get the react reference to the internal element" },
        { name: "getState()", type: "function", description: "Get the current state of the component" },
        { name: "setState(newState)", type: "function", description: "Change the component state" },
    ]

    static text1() {
        return (
            <p>Mauris ultrices placerat mauris, tempus ornare ligula sagittis at. Vestibulum aliquam id libero sit amet ultrices. 
            Phasellus at tempus ex, quis fringilla nisi. Donec euismod euismod nisl, ut scelerisque ipsum. Orci varius natoque 
            penatibus et magnis dis parturient montes, nascetur ridiculus mus. Ut nulla ligula, laoreet vitae molestie sit amet, 
            dapibus at nisi. </p>
        )
    }

    static text2() {
        return (
            <p>In id pulvinar turpis, et pharetra dui. Aliquam rhoncus condimentum nisi id elementum. Aenean vel efficitur nulla, eget porttitor nulla. 
            Etiam suscipit magna ac ex feugiat fringilla. Nam tincidunt orci sapien. Nam quis diam ut orci sollicitudin iaculis. 
            Nulla ut justo porttitor, commodo diam eu, fringilla urna. Ut eget faucibus augue. Quisque id ligula vel turpis feugiat aliquet eget ac 
            justo.</p>
        )
    }

    static text3() {
        return (
            <p>Donec in vehicula neque. Etiam ornare lectus sed enim cursus, ut vestibulum nibh condimentum. Phasellus vestibulum vitae mauris quis 
            scelerisque. Curabitur vitae cursus est. Cras ac porta sapien. Aliquam quis mattis mauris. Praesent ut bibendum felis. 
            Nullam sagittis semper quam et maximus. Suspendisse faucibus erat felis, sit amet dignissim ex euismod quis. </p>
        )
    }

}
